import React from 'react';
import { GlobalStyle } from './styles/GlobalStyles';
import { LanguageProvider } from './contexts/LanguageContext';
import AppContent from './components/AppContent';

function App() {
  return (
    <LanguageProvider>
      <GlobalStyle />
      <AppContent />
    </LanguageProvider>
  );
}

export default App;
